module.exports = __webpack_public_path__ + "static/media/IMG_8124.ce326b12.JPG";